import React from 'react';
import styles from './styles.module.scss';
import AppFooter from '../../components/AppFooter';
import LogoBB from '../../assets/img/LogoBB.svg';
import { Progress, Header, Button, Icon } from 'semantic-ui-react';

export default function CarregamentoApp({ reload, loadPercent, children, error }) {
    return (
        <div style={{ position: 'relative' }}>
            <div className={styles.containerOverlayer} />
            {/* <div className={headerStyles.divAppHeader}>
                <img className={headerStyles.logoBB} src={LogoBB} alt='Logo BB' onClick={() => this.onLogoClick()} />
            </div> */}
            <div className={`${styles.homeContainer} ${styles.carregamentoContainer}`}>
                <Header icon style={{ zIndex: '1' }}>
                    <div className={styles.logoBBContainer}>
                        <img src={LogoBB} alt={'Logo BB Seguros'} />{' '}
                    </div>
                </Header>
                <div className={styles.headerText}>{children}</div>
                <div className={styles.progressContainer}>
                    {error ? (
                        <>
                            <Button onClick={() => reload()} circular className={styles.btnRecarregar}>
                                <Icon name='refresh' /> Recarregar
                            </Button>
                        </>
                    ) : (
                        <Progress className={styles.progress} percent={loadPercent} style={{ width: '50%' }} />
                    )}
                </div>
            </div>
            <AppFooter />
        </div>
    );
}
